// PRHero.js - Australia
import React from 'react';
import { motion } from 'framer-motion';
import { CALENDLY_PR_AUSTRALIA } from '../../../constants';

const PRHero = () => {
  const handleBookConsultation = () => {
    window.open(CALENDLY_PR_AUSTRALIA, '_blank');
  };

  return (
    <section className="relative w-full h-[600px] md:h-[700px] overflow-hidden bg-white">
      <div className="max-w-7xl mx-auto h-full grid md:grid-cols-2">
        {/* Left Content */}
        <div className="flex flex-col justify-center px-4 md:px-8 py-12 bg-[#F5F8FA]">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            <span className="inline-block bg-white text-[#2542D4] text-xs font-light px-4 py-2 rounded-md mb-4">
              Permanent Residency - Australia
            </span>
            
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-[#202356] leading-tight mb-6">
              Your Path to Australian Permanent Residency
            </h1>
            
            <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-8 max-w-xl font-light">
              Navigate Australia's skilled migration pathways with expert guidance. From General Skilled Migration to State Nomination programs, we provide comprehensive support to help you achieve your permanent residency goals.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={handleBookConsultation}
                className="bg-[#202356] hover:bg-[#2d3270] text-white font-normal text-sm px-8 py-3 rounded-lg transition-colors text-center"
              >
                Book a PR Consultation
              </button>
            </div>
          </motion.div>
        </div>

        {/* Right Image */}
        <div className="relative hidden md:block">
          <div 
            className="absolute inset-0 bg-cover bg-center"
            style={{ 
              backgroundImage: `url(${require('../../../assets/australia-pr-hero.jpg')})`,
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default PRHero;
